export default {
    namespaced: true,
    state: () => ({
        spinner: {
            show: false
        }
    }),
    getters: {
        show(state) {
            return state.spinner.show
        }
    },
    mutations: {
        setLoading(state, payload) {
            state.spinner.show = payload
        },
    },
    actions: {
        setLoading({ commit }, show) {
            commit('setLoading', show)
        },
    },
}
